<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-home"></i><strong> Bienvenidos</strong>
              <div class="card-header-actions">
                  <small class="text-muted">-</small>
              </div>
            </div>
            <div class="text-center">
            </div>

         
            <div align="center">
               <img :src="img" />
              </div>
         

   
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>

</template>



<script>


  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'
  import VueSocketIO from 'vue-socket.io'
 

  Vue.use(ClientTable);


export default {
  name: 'inicio',
  created () {
      this.$store.dispatch('expireSession');
        

  },
  data () {

    return {
      data: '',
      modelScale: '',
      optionScales: [],
      img:"",

       
    }
  },
   sockets: {
        connect: function () {
            console.log('socket connected')
        },
       disconnect() {
     console.log('Desconectado')
      },
    receiveMessage(data) {

        if(this.modelScale==data.numberScale){

this.data=data.weight;

        }
      
console.log("recibiendo del server  "+data.weight);
      
     // this.socketMessage = data
    }
    },
    methods: {
    

        },
      mounted(){


     
 this.$axios.get('/api/scale/electronicscale/scale_detail/', {
          params: {
          location_id: 1
          }
          })
        .then(res => {



   // console.log(res.data.data[0].number);

    var pesas = res.data.data;

      
           for (let i in pesas)
          {
            this.optionScales.push({"value":pesas[i].number ,"text":pesas[i].name});

           }   
          

      

      var connectionDir =  String(pesas[0].connection.address);

      //console.log(connectionDir);

       Vue.use(new VueSocketIO({
      debug: true,
    //connection: 'http://localhost:2000',
    //connection: 'http://162.243.14.152:2000/'
      connection: connectionDir
    //options: { path: "/my-app/" } //Optional options
        }))

          
       

           })
         .catch(function (error) {
      console.log(error.response);
 });



 this.img=this.$store.getters.user.IMAGE;
    
 
    }
}

</script>
